<template>
  <div class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>孕婦乘車紀錄</h3>
          <hr />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h4 class="col-md-1">起始時間：</h4>
        <DateSelect ref="startTime" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h4 class="col-md-1">結束時間：</h4>
        <DateSelect ref="endTime" :isEndTime="true"></DateSelect>
      </div>
    </div>
    <el-row :gutter="10" style="margin-bottom: 1rem">
      <el-col :span="12">
        <h4 class="col-md-2">搜尋關鍵字:</h4>
        <input
          v-model="kw"
          type="text"
          required="required"
          class="search-input inputstyle fontSize16"
          placeholder="交易序號、訂單編號、呼號、原始金額、備註"
        />
        <el-button type="primary" @click="searchPayList" :loading="btnLoading">
          搜尋
        </el-button>
        <el-button type="info" @click="clearKeyword">清除</el-button>
      </el-col>
      <el-col :span="3">
        <h4 class="col-md-12">
          <i class="fa fa-user"></i>
          派車單總數:
          <span class="red_textcolor">{{ total }}</span>
        </h4>
      </el-col>
      <el-col :span="1">
        <el-button
          type="primary"
          :loading="loading"
          @click="download"
          :disabled="loading"
        >
          下載excel總表
        </el-button>
      </el-col>
    </el-row>

    <div class="col-md-12">
      <div class="x_panel">
        <div class="x_content">
          <div class="row">
            <div class="col-md-3">
              <label>
                <select
                  v-model="npp"
                  @change="getList"
                  name="datatable-checkbox_length"
                  aria-controls="datatable-checkbox"
                  class="form-control input-sm"
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>
          </div>

          <div class="tab-content" id="myTabContent">
            <div
              class="tab-pane fade active in"
              id="nav-credit-card"
              role="tabpanel"
              aria-labelledby="credit-card-tab"
            >
              <div class="table-responsive">
                <table class="table table-striped jambo_table bulk_action">
                  <thead>
                    <tr class="headings">
                      <th v-for="head in HEAD" class="column-title word_center">
                        {{ head }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="list.length > 0">
                      <tr
                        v-for="(row, index) in list"
                        v-bind:class="{
                          even: index % 2 == 0,
                          odd: index % 2 != 0,
                        }"
                        class="pointer"
                      >
                        <td class="word_center">{{ index + 1 }}</td>

                        <td class="word_center">{{ row.transaction_time }}</td>
                        <td class="word_center">{{ row.transaction_id }}</td>
                        <td class="word_center">{{ row.order_id }}</td>
                        <td class="word_center">
                          {{ row.team_id + ' / ' + row.driver_id }}
                        </td>
                        <td class="word_center">{{ row.uuid }}</td>
                        <td class="word_center">{{ row.payment }}</td>
                        <td class="word_center">{{ row.payment_limit }}</td>
                        <td class="word_center">
                          {{
                            row.payment - row.payment_limit >= 0
                              ? row.payment - row.payment_limit
                              : '0'
                          }}
                        </td>
                        <td class="word_center">{{ row.memo || '---' }}</td>
                      </tr>
                    </template>
                    <tr v-else>
                      <td colspan="11" class="word_center">查無資料</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="pull-right">
                <ul class="pagination">
                  <li v-bind:class="{ disabled: page == 1 }">
                    <a
                      href="javascript:;"
                      @click="clickNewPage(1)"
                      v-bind:class="{ active: page == 1 }"
                    >
                      第一頁
                    </a>
                  </li>
                  <li>
                    <a
                      href="javascript:;"
                      @click="clickNewPage(pages_show_list[0] - 1)"
                      v-show="page - 2 > 1 && pages_show_list[0] - 1 != 1"
                    >
                      ...
                    </a>
                  </li>
                  <li
                    v-for="n in pages_show_list"
                    v-bind:class="{ active: n == page }"
                    @click="clickNewPage(n)"
                  >
                    <a href="javascript:;" ng-bind="n">{{ n }}</a>
                  </li>
                  <li>
                    <a
                      href="javascript:;"
                      @click="clickNewPage(pages_show_list[4] + 1)"
                      v-show="
                        page + 2 < totalPage &&
                        pages_show_list[4] + 1 < totalPage
                      "
                    >
                      ...
                    </a>
                  </li>
                  <li
                    v-show="totalPage > 1"
                    v-bind:class="{ disabled: page == totalPage }"
                  >
                    <a
                      href="javascript:;"
                      @click="clickNewPage(totalPage)"
                      v-bind:class="{ active: page == totalPage }"
                    >
                      最後一頁
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DateSelect from '../../components/tool/DateSelect'
import API from '../../assets/js/libs/API'
import dayjs from 'dayjs'
import axios from 'axios'
import { pregnantService } from '@/constants/tableHead'
import { cookies } from '@/utils/cookies'

export default {
  name: 'PregnantService',
  components: {
    DateSelect,
  },
  data() {
    return {
      list: [],
      npp: 25,
      page: 1,
      kw: '',
      total: 0,
      totalPage: 0,
      startTime: dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      endTime: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      loading: false,
      btnLoading: false,
      HEAD: [],
    }
  },
  mounted() {
    this.$refs.startTime.setDate(this.startTime)
    this.$refs.endTime.setDate(this.endTime)
    this.getList()
  },
  methods: {
    download() {
      this.loading = true
      const start = dayjs(this.$refs.startTime.getDate()).format(
        'YYYY-MM-DD+HH:mm',
      )
      const end = dayjs(this.$refs.endTime.getDate()).format('YYYY-MM-DD+HH:mm')

      API.post(
        `https://staging.download.gladmobile.com/web/api/excel/pregnancy_subsidy-excel?start=${start}&end=${end}`,
        {},
        {
          responseType: 'blob',
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )
        .then((res) => {
          this.loading = false
          this.$msg('已成功，請至大量作業頁面查看')
          setTimeout(() => {
            try {
              window.open(
                '/#/serviceMain/WorkingStatus',
                '_blank',
                'noopener,noreferrer',
              )
            } catch (error) {
              console.error('開啟新分頁失敗:', error)
              this.$msg('無法開啟新分頁，請手動前往大量作業頁面')
            }
          }, 1500)
        })
        .catch((error) => {
          this.loading = false
          console.log(error)
          this.$msg('下載失敗，請稍後再試')
        })
    },
    clickNewPage(page) {
      this.page = page
      this.getList()
    },
    searchPayList() {
      let start_time = this.$refs.startTime.getDate()
      let end_time = this.$refs.endTime.getDate()
      if (dayjs(start_time).isAfter(end_time)) return alert('時間錯誤')
      this.startTime = dayjs(start_time).format('YYYY-MM-DD HH:mm:ss')
      this.endTime = dayjs(end_time).format('YYYY-MM-DD HH:mm:ss')
      this.getList()
    },
    clearKeyword() {
      this.kw = ''
      this.getList()
    },
    getList() {
      this.btnLoading = true
      axios
        .get(
          `${
            API.getPregnantServiceUrl
          }app/api/pregnancy/transactions?teamCode=${cookies.get(
            'GladTeamCode',
          )}&kw=${this.kw}&startDate=${this.startTime}&endDate=${
            this.endTime
          }&page=${this.page}&perPage=${this.npp}`,
          {
            headers: {
              'x-access-token': cookies.get('user'),
            },
          },
        )
        .then((res) => {
          this.btnLoading = false

          if (!res.data || !res.data.result || !res.data.result.result) {
            this.$msg('查詢失敗：無回應資料')
            this.list = []
            return
          }

          const responseData = res.data.result.result

          if (!Array.isArray(responseData.data)) {
            console.error('API 回應格式錯誤：', responseData)
            this.$msg('資料格式錯誤')
            this.list = []
            return
          }

          this.list = responseData.data
          this.total = responseData.total || 0
          this.totalPage = Math.ceil(this.total / this.npp)
        })
        .catch((err) => {
          this.btnLoading = false
          console.error('API 錯誤：', err)
          this.$msg('查詢失敗，請聯絡管理員')
          this.list = []
        })
    },
  },
  computed: {
    pages_show_list: function () {
      var pages_show_list = []
      var totalPage = this.totalPage
      var newCurrent = this.page
      if (totalPage < 7) {
        for (var i = 2; i < totalPage; i++) {
          pages_show_list.push(i)
        }
      } else {
        if (newCurrent <= 4) {
          for (var i = 2; i < 7; i++) {
            pages_show_list.push(i)
          }
        } else if (newCurrent <= totalPage && newCurrent >= totalPage - 3) {
          for (var i = totalPage - 5; i < totalPage; i++) {
            pages_show_list.push(i)
          }
        } else {
          for (var i = -2; i < 3; i++) {
            pages_show_list.push(newCurrent + i)
          }
        }
      }
      return pages_show_list
    },
  },
  created() {
    this.HEAD = pregnantService
  },
}
</script>
<style scoped>
.search-input {
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/pages/pregnantService/PregnantService.vue